import React, { Component } from "react";
import AntdPopconfirm, { PopconfirmProps } from "antd/lib/popconfirm";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/popconfirm/style";

export default class Popconfirm extends Component<PopconfirmProps> {
  render() {
    const { title, ...restProps } = this.props;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Popconfirm"
              {...this.props}
              render={eventprops => (
                <AntdPopconfirm title={title} {...restProps} {...eventprops} data-ui-role="Popconfirm"/>
              )}
            ></PagePoint>
          ) : (
            <AntdPopconfirm title={title} {...restProps}/>
          )
        }
      </ConfigConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/popconfirm/index.tsx